import React from "react";
import NextButton from "./NextButton";

function SkipOrNext({ handleClick, conditionForNext = true }) {
  return (
    <div className="flex flex-wrap justify-between gap-4 mt-6">
      <button
        onClick={(e) => handleClick(e, "skip")}
        type="button"
        className="ml-4 text-sm text-gray-400 hover:underline"
      >
        I&apos;ll do this later
      </button>
      <NextButton
        condition={conditionForNext}
        handleChange={(e) => handleClick(e, "next")}
      />
    </div>
  );
}

export default SkipOrNext;
